/* w9-rider-gallery (2026-10-24): the Rider Gallery page (sections/w9-rider-gallery-page.liquid)
   and a build's own page (sections/w9-rider-build-page.liquid, /pages/rider-gallery/<handle>).
   On the gallery:
     - fills the finder (Year / Make / Model, "Use my bike"), the riding-style chips and the color,
       wheel-line and verified filters from the cards' data-* attributes, with counts;
     - filters, sorts and pages the grid ("Load more");
     - cards open the build's own page; an old ?b=<handle> link is sent there. While builds have
       no pages of their own, Liquid renders each build's page hidden after the grid and ?b= shows
       it here instead (card clicks push it; Back returns);
     - opens on one bike with ?bike=<collection handle>.
   On a build (either way): the photo slider, "Same bike as yours", share links and the forum /
   website code that link back to the build, and its thumbs up and views from Crew Chief
   (rider_build_seen / rider_build_like, with the storefront's public key, like Ask Warp 9). A
   visitor is a random id in localStorage (w9_visitor); the row stays hidden unless Crew Chief
   answers.
   The rider's bike is w9_bike in localStorage (set by the fit check and bike finder). */
(function () {
  var root = document.querySelector('[data-w9rgp]');
  var standalone = document.querySelector('.w9rgb[data-w9rg-page]');
  if (!root && !standalone) return;
  var isGallery = !!root;
  if (!root) root = document;
  var index = root.querySelector('[data-w9rgp-index]');
  var grid = root.querySelector('[data-w9rgp-grid]');
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.w9rgc')) : [];
  var galleryPath = (isGallery && root.getAttribute('data-gallery-path')) || location.pathname;
  var pageSize = (isGallery && parseInt(root.getAttribute('data-page-size'), 10)) || 24;
  var baseTitle = document.title;

  function q(sel, el) { return (el || root).querySelector(sel); }
  function qa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function d(el, k) { return el.getAttribute('data-' + k) || ''; }
  function slug(s) { return String(s || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function pretty(s) { return String(s || '').replace(/-/g, ' '); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  /* The rider's bike */
  var myBike = null;
  try { myBike = JSON.parse(localStorage.getItem('w9_bike') || 'null'); } catch (e) {}
  var myPage = '', mySlug = '', myLabel = '';
  if (myBike) {
    myPage = (String(myBike.url || '').split('/collections/')[1] || '').split(/[?#\/]/)[0].toLowerCase();
    mySlug = slug((myBike.make || '') + ' ' + (myBike.model || ''));
    myLabel = myBike.label || ((myBike.make || '') + ' ' + (myBike.model || '')).trim();
  }
  function isMine(el) {
    if (!myBike) return false;
    var page = d(el, 'bike-page');
    if (myPage && page && page === myPage) return true;
    return !!mySlug && slug(d(el, 'make') + ' ' + d(el, 'model')) === mySlug;
  }

  /* ---------- The grid ---------- */
  var params = new URLSearchParams(location.search);
  var state = { year: '', make: '', model: '', mine: false, bike: params.get('bike') || '', style: '', rim: '', hub: '', lines: [], verified: false, sort: 'new', shown: pageSize };
  if (params.get('make')) state.make = params.get('make');
  if (params.get('model')) state.model = params.get('model');

  function matches(el, skip) {
    if (state.bike && skip !== 'bike' && d(el, 'bike-page') !== state.bike) return false;
    if (state.mine && skip !== 'mine' && !isMine(el)) return false;
    if (state.year && skip !== 'year' && d(el, 'year') !== state.year) return false;
    if (state.make && skip !== 'make' && d(el, 'make') !== state.make) return false;
    if (state.model && skip !== 'model' && d(el, 'model') !== state.model) return false;
    if (state.style && skip !== 'style' && ('|' + d(el, 'styles') + '|').indexOf('|' + state.style + '|') < 0) return false;
    if (state.rim && skip !== 'rim' && d(el, 'rim') !== state.rim) return false;
    if (state.hub && skip !== 'hub' && d(el, 'hub') !== state.hub) return false;
    if (state.lines.length && skip !== 'line' && state.lines.indexOf(d(el, 'line')) < 0) return false;
    if (state.verified && skip !== 'verified' && d(el, 'verified') !== 'true') return false;
    return true;
  }
  /* Values of one attribute among the cards that pass every other filter, with counts. */
  function facet(attr, skip, multi) {
    var out = {};
    cards.forEach(function (el) {
      if (!matches(el, skip)) return;
      (multi ? d(el, attr).split('|') : [d(el, attr)]).forEach(function (v) {
        if (v) out[v] = (out[v] || 0) + 1;
      });
    });
    return out;
  }
  function keep(list, v) { if (v && list.indexOf(v) < 0) list.push(v); return list; }

  function fillSelect(sel, values, counts, placeholder, current) {
    if (!sel) return;
    sel.innerHTML = '';
    var o = document.createElement('option');
    o.value = '';
    o.textContent = placeholder;
    sel.appendChild(o);
    values.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v + ' (' + (counts[v] || 0) + ')';
      sel.appendChild(opt);
    });
    sel.value = current || '';
  }

  var selYear = q('[data-w9rg-f="year"]');
  var selMake = q('[data-w9rg-f="make"]');
  var selModel = q('[data-w9rg-f="model"]');
  var btnMine = q('[data-w9rg-f="mine"]');
  var chipBox = q('[data-w9rg-f="style"]');
  var rimBox = q('[data-w9rg-f="rim"]');
  var hubBox = q('[data-w9rg-f="hub"]');
  var lineBox = q('[data-w9rg-f="line"]');
  var chkVerified = q('[data-w9rg-f="verified"]');
  var selSort = q('[data-w9rg-f="sort"]');
  var moreBtn = q('[data-w9rg-more]');
  var empty = q('[data-w9rg-empty]');
  var countEl = q('[data-w9rg-count]');
  var scopeEl = q('[data-w9rg-scope]');

  function renderControls() {
    var years = facet('year', 'year');
    fillSelect(selYear, keep(Object.keys(years), state.year).sort(function (a, b) { return b - a; }), years, 'Any year', state.year);
    var makes = facet('make', 'make');
    fillSelect(selMake, keep(Object.keys(makes), state.make).sort(), makes, 'Any make', state.make);
    if (selModel) {
      if (state.make) {
        var models = facet('model', 'model');
        fillSelect(selModel, keep(Object.keys(models), state.model).sort(), models, 'Any ' + state.make + ' model', state.model);
        selModel.disabled = false;
      } else {
        fillSelect(selModel, [], {}, 'Pick a make first', '');
        selModel.disabled = true;
      }
    }
    if (btnMine) {
      var mineCount = cards.filter(isMine).length;
      btnMine.hidden = !myBike || !mineCount;
      btnMine.setAttribute('aria-pressed', state.mine ? 'true' : 'false');
      q('[data-w9rg-mine-label]').textContent = state.mine ? 'Showing my ' + myLabel : 'Use my bike: ' + myLabel;
    }

    if (chipBox) {
      var styles = facet('styles', 'style', true);
      var all = cards.filter(function (el) { return matches(el, 'style'); }).length;
      chipBox.innerHTML = '';
      [''].concat(keep(Object.keys(styles), state.style).sort()).forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'w9rgp__chip';
        b.setAttribute('aria-pressed', state.style === s ? 'true' : 'false');
        b.setAttribute('data-style', s);
        b.innerHTML = '';
        b.appendChild(document.createTextNode(s || 'All'));
        var small = document.createElement('small');
        small.textContent = ' ' + (s ? styles[s] || 0 : all);
        b.appendChild(small);
        chipBox.appendChild(b);
      });
    }

    [['rim', rimBox], ['hub', hubBox]].forEach(function (pair) {
      var key = pair[0], box = pair[1];
      if (!box) return;
      var counts = facet(key, key);
      var hex = {};
      cards.forEach(function (el) { if (d(el, key)) hex[d(el, key)] = d(el, key + '-hex'); });
      var names = keep(Object.keys(counts), state[key]).sort();
      box.innerHTML = '';
      names.forEach(function (name) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'w9rgp__sw';
        b.setAttribute('data-' + key, name);
        b.setAttribute('aria-pressed', state[key] === name ? 'true' : 'false');
        b.setAttribute('aria-label', pretty(name) + ' ' + key + 's (' + (counts[name] || 0) + ')');
        var i = document.createElement('i');
        i.style.background = hex[name] || '#d0d0d0';
        b.appendChild(i);
        b.appendChild(document.createTextNode(pretty(name)));
        box.appendChild(b);
      });
      box.closest('.w9rgp__fgroup').hidden = !names.length;
      var clear = q('[data-w9rg-clear="' + key + '"]');
      if (clear) clear.hidden = !state[key];
    });

    if (lineBox) {
      var lines = facet('line', 'line');
      var names = Object.keys(lines);
      state.lines.forEach(function (l) { keep(names, l); });
      lineBox.innerHTML = '';
      names.sort().forEach(function (l) {
        var lab = document.createElement('label');
        var c = document.createElement('input');
        c.type = 'checkbox';
        c.value = l;
        c.checked = state.lines.indexOf(l) >= 0;
        lab.appendChild(c);
        lab.appendChild(document.createTextNode(' ' + l + ' '));
        var s = document.createElement('span');
        s.textContent = '(' + (lines[l] || 0) + ')';
        lab.appendChild(s);
        lineBox.appendChild(lab);
      });
      lineBox.closest('.w9rgp__fgroup').hidden = !names.length;
    }
  }

  function sorted(list) {
    var by = {
      'new': function (a, b) { return (+d(b, 'live')) - (+d(a, 'live')); },
      photos: function (a, b) { return (+d(b, 'photos')) - (+d(a, 'photos')) || (+d(b, 'live')) - (+d(a, 'live')); },
      parts: function (a, b) { return (+d(b, 'parts')) - (+d(a, 'parts')) || (+d(b, 'live')) - (+d(a, 'live')); },
      pick: function (a, b) { return (d(b, 'pick') === 'true') - (d(a, 'pick') === 'true') || (+d(b, 'live')) - (+d(a, 'live')); }
    }[state.sort] || null;
    return by ? list.slice().sort(by) : list;
  }

  function scopeLabel() {
    var parts = [];
    if (state.mine) parts.push('for your ' + myLabel);
    else if (state.model) parts.push('for the ' + state.make + ' ' + state.model);
    else if (state.make) parts.push('for ' + state.make);
    else if (state.bike) {
      var c = cards.filter(function (el) { return d(el, 'bike-page') === state.bike; })[0];
      if (c) parts.push('for the ' + d(c, 'make') + ' ' + d(c, 'model'));
    }
    if (state.year) parts.push('(' + state.year + ')');
    if (state.rim) parts.push('with ' + pretty(state.rim).toLowerCase() + ' rims');
    if (state.hub) parts.push((state.rim ? 'and ' : 'with ') + pretty(state.hub).toLowerCase() + ' hubs');
    if (state.style) parts.push('· ' + state.style);
    if (state.lines.length) parts.push('· ' + state.lines.join(', '));
    if (state.verified) parts.push('· verified buyers');
    return parts.join(' ');
  }

  function renderGrid() {
    if (!grid) return;
    var shown = sorted(cards.filter(function (el) { return matches(el); }));
    var showSet = shown.slice(0, state.shown);
    cards.forEach(function (el) { el.hidden = true; });
    shown.forEach(function (el, i) { grid.appendChild(el); el.hidden = i >= state.shown; });
    cards.forEach(function (el) {
      var badge = el.querySelector('[data-w9rg-mine]');
      if (badge) badge.hidden = !isMine(el);
    });
    if (countEl) countEl.textContent = plural(shown.length, 'build', 'builds');
    if (scopeEl) scopeEl.textContent = scopeLabel();
    if (empty) empty.hidden = shown.length > 0;
    if (moreBtn) {
      var left = shown.length - showSet.length;
      moreBtn.hidden = left <= 0;
      moreBtn.textContent = 'Load more builds (' + Math.min(left, pageSize) + ' more)';
    }
  }

  function update() { renderControls(); renderGrid(); }
  function reset() {
    state.year = state.make = state.model = state.style = state.rim = state.hub = state.bike = '';
    state.mine = state.verified = false;
    state.lines = [];
    state.shown = pageSize;
    if (chkVerified) chkVerified.checked = false;
    update();
  }

  if (selYear) selYear.addEventListener('change', function () { state.year = selYear.value; state.shown = pageSize; update(); });
  if (selMake) selMake.addEventListener('change', function () { state.make = selMake.value; state.model = ''; state.mine = false; state.bike = ''; state.shown = pageSize; update(); });
  if (selModel) selModel.addEventListener('change', function () { state.model = selModel.value; state.mine = false; state.bike = ''; state.shown = pageSize; update(); });
  if (btnMine) btnMine.addEventListener('click', function () { state.mine = !state.mine; state.make = state.model = state.year = state.bike = ''; state.shown = pageSize; update(); });
  if (chipBox) chipBox.addEventListener('click', function (e) {
    var b = e.target.closest('[data-style]');
    if (!b) return;
    state.style = b.getAttribute('data-style');
    state.shown = pageSize;
    update();
  });
  [['rim', rimBox], ['hub', hubBox]].forEach(function (pair) {
    var key = pair[0], box = pair[1];
    if (!box) return;
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-' + key + ']');
      if (!b) return;
      var v = b.getAttribute('data-' + key);
      state[key] = state[key] === v ? '' : v;
      state.shown = pageSize;
      update();
    });
    var clear = q('[data-w9rg-clear="' + key + '"]');
    if (clear) clear.addEventListener('click', function () { state[key] = ''; update(); });
  });
  if (lineBox) lineBox.addEventListener('change', function () {
    state.lines = qa('input:checked', lineBox).map(function (c) { return c.value; });
    state.shown = pageSize;
    update();
  });
  if (chkVerified) chkVerified.addEventListener('change', function () { state.verified = chkVerified.checked; state.shown = pageSize; update(); });
  if (selSort) selSort.addEventListener('change', function () { state.sort = selSort.value; renderGrid(); });
  if (moreBtn) moreBtn.addEventListener('click', function () { state.shown += pageSize; renderGrid(); });
  qa('[data-w9rg-reset]').forEach(function (b) { b.addEventListener('click', reset); });

  var filters = q('[data-w9rgp-filters]');
  if (filters && window.matchMedia('(min-width: 990px)').matches) filters.open = true;

  /* ---------- Thumbs up and views ---------- */
  var CC_RPC = 'https://rlvfbygilzvwzndttzaj.supabase.co/rest/v1/rpc/';
  var CC_KEY = 'sb_publishable_B_Pn7p7VNmQBcrK5zrsbDA_jnkrv1B3'; // public by design, like Ask Warp 9's
  var SHOW_VIEWS = 10; // fewer than this and the page shows no view count
  var BOT = /bot|crawl|spider|slurp|preview|headless|lighthouse/i;

  function visitor() {
    var v = null;
    try { v = localStorage.getItem('w9_visitor'); } catch (e) {}
    if (!v || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(v)) {
      v = window.crypto && crypto.randomUUID ? crypto.randomUUID() :
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0;
          return (c === 'x' ? r : (r & 3 | 8)).toString(16);
        });
      try { localStorage.setItem('w9_visitor', v); } catch (e) {}
    }
    return v;
  }
  function rpc(fn, body) {
    return fetch(CC_RPC + fn, {
      method: 'POST',
      headers: { apikey: CC_KEY, 'content-type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function react(a, handle) {
    var box = q('[data-w9rg-react]', a);
    if (!box || !window.fetch || navigator.webdriver || BOT.test(navigator.userAgent)) return;
    var btn = q('[data-w9rg-like]', box);
    var likeN = q('[data-w9rg-like-n]', box);
    var views = q('[data-w9rg-views]', box);
    var viewsN = q('[data-w9rg-views-n]', box);
    var me = visitor();
    var now = null;
    function show(r) {
      now = r;
      box.hidden = false;
      btn.setAttribute('aria-pressed', r.liked ? 'true' : 'false');
      btn.setAttribute('aria-label', 'Thumbs up' + (r.likes ? ', ' + r.likes : ''));
      btn.title = r.liked ? 'You gave this a thumbs up. Tap again to take it back' : 'Give this build a thumbs up';
      likeN.textContent = r.likes > 0 ? r.likes.toLocaleString() : 'Thumbs up';
      views.hidden = !(r.views >= SHOW_VIEWS);
      viewsN.textContent = r.views.toLocaleString() + (r.views === 1 ? ' view' : ' views');
    }
    /* A view counts once the page has been on screen for a moment. */
    function seen() {
      rpc('rider_build_seen', { p_handle: handle, p_visitor: me }).then(function (r) { if (r && r.ok) show(r); });
    }
    if (document.visibilityState === 'visible') setTimeout(seen, 1500);
    else document.addEventListener('visibilitychange', function once() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', once);
      setTimeout(seen, 1500);
    });
    btn.addEventListener('click', function () {
      if (!now || btn.disabled) return;
      var was = now;
      var on = !was.liked;
      show({ ok: true, liked: on, likes: Math.max(0, was.likes + (on ? 1 : -1)), views: was.views });
      if (on) {
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
      }
      btn.disabled = true;
      rpc('rider_build_like', { p_handle: handle, p_visitor: me, p_on: on }).then(function (r) {
        btn.disabled = false;
        show(r && r.ok ? r : was);
      });
    });
  }

  /* ---------- A build's page ---------- */
  var builds = {};
  qa('.w9rgb').forEach(function (a) { builds[d(a, 'handle')] = a; });
  var current = null;
  var indexScroll = 0;

  function urlFor(handle) {
    var p = new URLSearchParams(location.search);
    if (handle) p.set('b', handle); else p.delete('b');
    var s = p.toString();
    return location.pathname + (s ? '?' + s : '');
  }
  function shareUrl(handle) { return location.origin + galleryPath + '?b=' + encodeURIComponent(handle); }

  function copy(text, btn, done) {
    function ok() {
      if (!btn) return;
      var label = btn.querySelector('span') || btn;
      var was = label.textContent;
      btn.classList.add('is-done');
      label.textContent = done || 'Copied';
      setTimeout(function () { btn.classList.remove('is-done'); label.textContent = was; }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok, function () { fallback(); });
    } else fallback();
    function fallback() {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      document.body.removeChild(t);
    }
  }

  function setup(a) {
    if (a.getAttribute('data-ready')) return;
    a.setAttribute('data-ready', '1');
    var handle = d(a, 'handle');
    var title = d(a, 'title');
    var rider = d(a, 'rider');
    var url = d(a, 'url') || shareUrl(handle);
    var img = d(a, 'img');
    var text = title + ' by ' + rider + ' on the Warp 9 Rider Gallery';

    /* Photos: a swipeable strip; arrows and thumbs scroll it. */
    var track = q('[data-w9rg-track]', a);
    var slides = track ? qa('.w9rgb__slide', track) : [];
    var nEl = q('[data-w9rg-n]', a);
    var thumbs = qa('[data-w9rg-thumb]', a);
    var prev = q('[data-w9rg-prev]', a);
    var next = q('[data-w9rg-next]', a);
    function at() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    function go(i) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function mark() {
      var i = at();
      if (nEl) nEl.textContent = i + 1;
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    if (track) {
      var tick = null;
      track.addEventListener('scroll', function () { clearTimeout(tick); tick = setTimeout(mark, 60); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(at() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(at() - 1); }
      });
      /* Load the first two photos now; the rest load as they come into view. */
      slides.slice(0, 2).forEach(function (s) { var im = s.querySelector('img'); if (im) im.loading = 'eager'; });
    }
    if (prev) prev.addEventListener('click', function () { go(at() - 1); });
    if (next) next.addEventListener('click', function () { go(at() + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-w9rg-thumb')); }); });
    mark();

    /* Share */
    var enc = encodeURIComponent;
    var to = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + enc(url),
      reddit: 'https://www.reddit.com/submit?url=' + enc(url) + '&title=' + enc(text),
      x: 'https://x.com/intent/post?url=' + enc(url) + '&text=' + enc(text),
      pinterest: 'https://www.pinterest.com/pin/create/button/?url=' + enc(url) + '&media=' + enc(img) + '&description=' + enc(text)
    };
    qa('[data-w9rg-to]', a).forEach(function (l) {
      var k = l.getAttribute('data-w9rg-to');
      if (k === 'pinterest' && !img) { l.hidden = true; return; }
      l.href = to[k];
    });
    var code = {
      link: url,
      bb: (img ? '[url=' + url + '][img]' + img + '[/img][/url]\n' : '') + '[url=' + url + ']' + text + '[/url]',
      html: '<a href="' + url + '">' + (img ? '<img src="' + img + '" alt="' + title.replace(/"/g, '&quot;') + '" width="800"><br>' : '') + text.replace(/</g, '&lt;') + '</a>'
    };
    qa('[data-w9rg-code]', a).forEach(function (t) { t.value = code[t.getAttribute('data-w9rg-code')] || ''; });
    qa('[data-w9rg-copy]', a).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-w9rg-copy');
        copy(code[k], b, k === 'link' ? 'Link copied' : 'Copied');
      });
    });
    var native = q('[data-w9rg-native]', a);
    if (native && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', function () { navigator.share({ title: title, text: text, url: url }).catch(function () {}); });
    }

    react(a, handle);

    /* Same bike as yours */
    var mine = q('[data-w9rg-mine]', a);
    if (mine) mine.hidden = !isMine(a);

    /* More builds: same riding style first, then the same make. (A build's own page renders
       them in Liquid.) */
    var moreSec = q('[data-w9rg-more]', a);
    var moreGrid = q('[data-w9rg-more-grid]', a);
    if (moreSec && moreGrid && !moreGrid.children.length) {
      var style = d(a, 'style'), make = d(a, 'make');
      var others = cards.filter(function (el) { return d(el, 'handle') !== handle; });
      var same = others.filter(function (el) { return style && ('|' + d(el, 'styles') + '|').indexOf('|' + style + '|') >= 0; });
      var rest = others.filter(function (el) { return same.indexOf(el) < 0 && d(el, 'make') === make; });
      var pick = same.concat(rest).concat(others.filter(function (el) { return same.indexOf(el) < 0 && rest.indexOf(el) < 0; })).slice(0, 4);
      pick.forEach(function (el) {
        var c = el.cloneNode(true);
        c.hidden = false;
        moreGrid.appendChild(c);
      });
      moreSec.hidden = !pick.length;
    }
  }

  /* The theme scrolls smoothly; switching between the grid and a build should not. */
  function jump(y) { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }

  function show(handle, push) {
    var a = handle ? builds[handle] : null;
    if (handle && !a) handle = '';
    if (a && !current) indexScroll = window.pageYOffset;
    if (current) current.hidden = true;
    current = a || null;
    if (index) index.hidden = !!a;
    if (a) {
      a.hidden = false;
      setup(a);
      document.title = d(a, 'title') + ' by ' + d(a, 'rider') + ' | Warp 9 Rider Gallery';
      jump(Math.max(0, root.getBoundingClientRect().top + window.pageYOffset - 16));
    } else {
      document.title = baseTitle;
      jump(indexScroll);
    }
    if (push) history.pushState({ w9rg: handle || '' }, '', urlFor(handle));
  }

  if (!isGallery) {
    setup(standalone);
    return;
  }

  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var card = e.target.closest('a.w9rgc');
    if (card && builds[d(card, 'handle')]) {
      e.preventDefault();
      show(d(card, 'handle'), true);
      return;
    }
    var back = e.target.closest('[data-w9rg-back]');
    if (back && current) {
      e.preventDefault();
      if (history.state && history.state.w9rg) history.back();
      else show('', true);
    }
  });
  window.addEventListener('popstate', function () {
    show(new URLSearchParams(location.search).get('b') || '', false);
  });

  update();
  var first = params.get('b');
  if (first && builds[first]) show(first, false);
  else if (first) {
    /* An old ?b= link to a build that now has its own page. */
    var to = cards.filter(function (el) { return d(el, 'handle') === first; })[0];
    if (to && to.getAttribute('href').indexOf('?b=') < 0) location.replace(to.href);
  }
})();
